module.exports = __webpack_public_path__ + "static/nav-logo-f68fa8b014e293610cecf24472ebe608.jpg";